export const deClientPortalUserSettingsPagePages = {
    settings: {
        userSettingsPage: {
            locales: {
                'de-DE': 'Deutsch',
                'en-US': 'Englisch',
            },
            actions: {
                continueToOrders: 'Weiter zu Bewertungsaufträgen',
            },
            modal: {
                title: 'Einstellungen',
                tabs: {
                    general: 'Allgemein',
                    notifications: 'Benachrichtigungen',
                },
                unsavedChanges: {
                    title: 'Nicht gespeicherte Änderungen',
                    message: 'Was soll mit Ihren Änderungen passieren, bevor Sie fortfahren?',
                    discardAndContinue: 'Verwerfen & weiter',
                    saveAndContinue: 'Speichern & weiter',
                },
                profileImage: 'Profilbild',
                uploadImage: 'Hochladen',
                removeImage: 'Entfernen',
                removeImageConfirmation: {
                    title: 'Profilbild entfernen?',
                    message: 'Ihr Profilbild wird dauerhaft entfernt. Möchten Sie fortfahren?',
                },
                rowLabels: {
                    email: 'E-Mail',
                    phoneNumber: 'Telefon',
                },
            },
            profile: {
                personalProfile: 'Persönliches Profil',
                logout: 'Abmelden',
                headerImageAlt: 'Allgemeines Titelbild',
                userImageAlt: 'Benutzerbild',
                uploadImageAriaLabel: 'Profilbild hochladen',
                teamSectionTitle: 'Team',
            },
        },
    },
}

export const deClientPortalUserSettingsPageValidation = {
    required: 'Pflichtfeld',
    invalidPhoneNumber: 'Keine gültige Telefonnummer',
}
